module.exports = __webpack_public_path__ + "img/output_1.e4fc7eef.png";